export function pageMasterTitle() {
  return 'Kalenderhaus.de';
}

export function childDidReMountAsyncOverrides() {
  //Moluns
  /*
  let ga =
    window.ga ||
    function () {
      (ga.q = ga.q || []).push(arguments);
    };
  ga.l = +new Date();

  ga('create', 'UA-55782022-1', 'auto');
  ga('set', 'anonymizeIp', true);
  // ga('send', 'pageview', location.pathname + location.search);
  ga('send', 'pageview');
  */
}

export function basePageHeaderGetterOverrides() {
  return `<script async src="https://www.googletagmanager.com/gtag/js?id=G-6QEWFQ8ZEN"></script>
   <script>
     window.dataLayer = window.dataLayer || [];
     function gtag(){dataLayer.push(arguments);}
     gtag('js', new Date());
   
     gtag('config', 'G-6QEWFQ8ZEN');
     if(window.ga == undefined){
       window.ga = window.gtag;
     }
   </script>`;
}

export function basePagePostBodyInjectionOverrides() {
  let postBodyInject = '';
  //Moluna
  /*
  if (process.env.NODE_ENV != 'development') {
    postBodyInject += `<!-- Google Tag Manager (noscript) -->
  <noscript
    ><iframe
      src="https://www.googletagmanager.com/ns.html?id=GTM-NT6FRD6"
      height="0"
      width="0"
      style="display: none; visibility: hidden"
    ></iframe
  ></noscript>
  <!-- End Google Tag Manager (noscript) -->
  <!-- Start Webgains TAG Manager-->

  <!-- Allgemeiner Tag -->
  <noscript
    ><iframe
      src="//tm.container.webgains.link/tm/a/container/noscript/666d905ba9.html"
      height="0"
      width="0"
      style="display: none; visibility: hidden"
    ></iframe
  ></noscript>
  <script>
    (function (n, e, o, r, y) {
      n[r] = n[r] || [];
      n[r].push({ event: "ntmInit", t: new Date().getTime() });
      var f = e.getElementsByTagName(o)[0],
        s = e.createElement(o),
        d = r != "ntmData" ? "&ntmData=" + r : "";
      s.async = true;
      s.src =
        "http" +
        (document.location.protocol == "https:" ? "s" : "") +
        "://tm.container.webgains.link/tm/a/container/init/" +
        y +
        ".js?" +
        d +
        "&rnd=" +
        Math.floor(Math.random() * 100000000);
      f.parentNode.insertBefore(s, f);
    })(window, document, "script", "ntmData", "666d905ba9");
  </script>

  <!-- End Webgains TAG Manager-->

  <!--Start Webgains Landingpage Script -->
  <script>
    (function (w, e, b, g, a, i, n, s) {
      w["ITCLKOBJ"] = a;
      (w[a] =
        w[a] ||
        function () {
          (w[a].q = w[a].q || []).push(arguments);
        }),
        (w[a].l = 1 * new Date());
      (i = e.createElement(b)), (n = e.getElementsByTagName(b)[0]);
      i.async = 1;
      i.src = g;
      n.parentNode.insertBefore(i, n);
    })(
      window,
      document,
      "script",
      "https://analytics.webgains.io/clk.min.js",
      "ITCLKQ"
    );
    ITCLKQ("set", "internal.api", true);
    ITCLKQ("set", "internal.cookie", true);
    ITCLKQ("click");
  </script>
  <!--End Webgains Landingpage Script -->`;
  }
*/
  return postBodyInject;
}
